let API_URL = 'https://aiducatorstagingapis.ctsdemo.ae';
let API_URL_V2 = 'https://aiducatorstagingapis.ctsdemo.ae';

let UploadURL =
  'https://aiducatorstagingapis.ctsdemo.ae/Azure/UploadBlobToContainer';

// let API_URL = 'https://aiducatorstaging.ctsdemo.ae';
// let API_URL_V2 = 'https://aiducatorstaging.ctsdemo.ae/';

// let UploadURL =
//   'https://aiducatorv1.4apis.ctsdemo.ae/Azure/UploadBlobToContainer';

export { API_URL, UploadURL, API_URL_V2 };
